<template>
  <div>
    <div class="print" id="printThis" style="background:#fff!important; padding:40px; width:1000px; margin:auto;">
      <div id="mailThis" style="background:#fff!important; width:920px; margin:auto;">
        <div style="align-items:center;">
          <h3 style="margin-bottom:25px; margin-top:16px !important; color:#000; font-weight:bold; text-align:center;">IZVEŠTAJ O ZDRAVSTVENOM PREGLEDU</h3>
          <img
            v-if="myInfo.logo"
            style="margin:auto; width: 100%; max-width:100px; display: block; text-align:center; margin-bottom:12px;"
            :src="myInfo.logo"
            alt="Logo"
          />
          <h3 style="text-align: center; margin-bottom: 0px;">{{ myInfo.companyName }}</h3>
          <div style="display: flex; justify-content: center; margin-bottom:25px;">
            <p style="text-align: center; width: 100%; margin-top: 5px;">
            <span style="margin-left: 15px;" v-if="myInfo.email">{{myInfo.email}}</span>
            <span style="margin-left: 15px;" v-if="myInfo.mobilePhone">{{myInfo.mobilePhone}}</span>
            <span style="margin-left: 15px;" v-if="myInfo.phone">{{myInfo.phone}}</span>
            </p>
          </div>
        </div>
        <div style="display: flex; flex-wrap: wrap; margin-top: 20px;">
          <h5 style="text-decoration: underline; margin-bottom: 5px;">Generalije</h5>
        </div>
        <div style="display:flex; flex-wrap: wrap;">
          <div style="display:flex; flex-wrap: wrap; flex:0 0 100%; width: 100%;">
            <div style="flex:0 0 33.33%; width: 33.33%;" v-if="ownerInfoCertificate.name || ownerInfoCertificate.surname">
              <p
                style="font-weight:bold; margin-bottom: 0;"
              >
                Ime i prezime vlasnika
              </p>
               <p style="margin-bottom: 0;"
              >
                {{
                  ownerInfoCertificate.name + " " + ownerInfoCertificate.surname
                }}
              </p>
            </div>
            <div style="flex:0 0 33.33%; width: 33.33%;" v-if="petInfo.name">
              <p style="font-weight:bold; margin-bottom: 0;">Ime životinje</p>
              <p style="margin-bottom: 5px;">{{ petInfo.name }}</p>
            </div>
            <div style="flex:0 0 33.33%; width: 33.33%;" v-if="petInfo.type">
              <p style="font-weight:bold; margin-bottom: 0;">Vrsta</p>
              <p style="margin-bottom: 5px;">{{ petInfo.type }}</p>
            </div>
            <div style="flex:0 0 33.33%; width: 33.33%;" v-if="petInfo.breed">
              <p style="font-weight:bold; margin-bottom: 0;">Rasa</p>
              <p style="margin-bottom: 5px;">{{ petInfo.breed }}</p>
            </div>
            <div style="flex:0 0 33.33%; width: 33.33%;" v-if="petInfo.gender">
              <p style="font-weight:bold; margin-bottom: 0;">Pol</p>
              <p style="margin-bottom: 5px;">{{ petInfo.gender }}</p>
            </div>
            <div style="flex:0 0 33.33%; width: 33.33%;" v-if="petInfo.dateOfBirth">
              <p style="font-weight:bold; margin-bottom: 0;">Datum rođenja</p>
              <p style="margin-bottom: 5px;">{{ petInfo.dateOfBirth }}</p>
            </div>
            <div style="flex:0 0 33.33%; width: 33.33%;" v-if="petInfo.microChipNo">
              <p style="font-weight:bold; margin-bottom: 0;">
                Broj mikročipa
              </p>
              <p style="margin-bottom: 5px;">{{ petInfo.microChipNo }}</p>
            </div>
            <div style="flex:0 0 33.33%; width: 33.33%;" v-if="petInfo.passportNo">
              <p style="font-weight:bold; margin-bottom: 0;">
                Broj pasoša
              </p>
              <p style="margin-bottom: 5px;">{{ petInfo.passportNo }}</p>
            </div>
            <div style="flex:0 0 33.33%; width: 33.33%;" v-if="ownerInfoCertificate.address">
              <p style="font-weight:bold; margin-bottom: 0;">
                Adresa
              </p>
              <p style="margin-bottom: 5px;">
                {{ ownerInfoCertificate.address }}
              </p>
            </div>
            <!-- <div style="flex:0 0 50%; width: 50%;">
              <p v-if="petInfo.name">{{ petInfo.name }}</p>
              <p v-if="petInfo.type">{{ petInfo.type }}</p>
              <p v-if="petInfo.breed">{{ petInfo.breed }}</p>
              <p v-if="petInfo.gender">{{ petInfo.gender }}</p>
              <p v-if="petInfo.dateOfBirth">{{ petInfo.dateOfBirth }}</p>
            </div> -->
          </div>
          <!-- <div style="display:flex; flex:0 0 50%; width: 50%;"> -->
            <!-- <div style="flex:0 0 50%; width: 50%;">
              <p v-if="petInfo.microChipNo" style="font-weight:bold; margin-bottom: 0;">
                Broj mikročipa
              </p>
              <p v-if="petInfo.microChipNo">{{ petInfo.microChipNo }}</p>
              <p v-if="petInfo.passportNo" style="font-weight:bold; margin-bottom: 0;">
                Broj pasoša
              </p>
              <p v-if="petInfo.passportNo">{{ petInfo.passportNo }}</p>
              <p style="color:#fff!important;">-</p>
              <p
                v-if="ownerInfoCertificate.name || ownerInfoCertificate.surname"
                style="font-weight:bold; margin-bottom: 0;"
              >
                Ime i prezime vlasnika
              </p>
               <p
                v-if="ownerInfoCertificate.name || ownerInfoCertificate.surname"
              >
                {{
                  ownerInfoCertificate.name + " " + ownerInfoCertificate.surname
                }}
              </p>
              <p v-if="ownerInfoCertificate.address" style="font-weight:bold; margin-bottom: 0;">
                Adresa
              </p>
              <p v-if="ownerInfoCertificate.address">
                {{ ownerInfoCertificate.address }}
              </p>
            </div> -->
            <!-- <div style="flex:0 0 50%; width: 50%;">
              <p v-if="petInfo.microChipNo">{{ petInfo.microChipNo }}</p>
              <p v-if="petInfo.passportNo">{{ petInfo.passportNo }}</p>
              <p style="color:#fff!important;">-</p>
              <p
                v-if="ownerInfoCertificate.name || ownerInfoCertificate.surname"
              >
                {{
                  ownerInfoCertificate.name + " " + ownerInfoCertificate.surname
                }}
              </p>
              <p v-if="ownerInfoCertificate.address">
                {{ ownerInfoCertificate.address }}
              </p>
            </div> -->
          <!-- </div> -->
        </div>
        
        <div style="display: flex; flex-wrap: wrap; margin-top: 20px;" v-if="examinationInfo.specijalneMetodeDijagnostike || examinationInfo.anamneza || examinationInfo.klinickaSlika || examinationInfo.dijagnoza || examinationInfo.terapija || examinationInfo.napomena">
          <h5 style="text-decoration: underline; margin-bottom: 5px;">Pregled</h5>
        </div>
        <div style="display: flex; flex-wrap: wrap;">
          <div v-if="examinationInfo.specijalneMetodeDijagnostike" style="flex:0 0 50%; width: 50%;">
            <p style="font-weight:bold; margin-bottom: 0;">Specijalne metode dijagnostike:</p>
            <p>{{ examinationInfo.specijalneMetodeDijagnostike }}</p>
          </div>
          <div v-if="examinationInfo.anamneza" style="flex:0 0 50%; width: 50%;">
            <p style="font-weight:bold; margin-bottom: 0;">Anamneza:</p>
            <p>{{ examinationInfo.anamneza }}</p>
          </div>
          <div v-if="examinationInfo.klinickaSlika" style="flex:0 0 50%; width: 50%;">
            <p style="font-weight:bold; margin-bottom: 0;">Klinička slika:</p>
            <p>{{ examinationInfo.klinickaSlika }}</p>
          </div>
          <div v-if="examinationInfo.dijagnoza" style="flex:0 0 50%; width: 50%;">
            <p style="font-weight:bold; margin-bottom: 0;">Dijagnoza</p>
            <p>{{ examinationInfo.dijagnoza }}</p>
          </div>
          <div v-if="examinationInfo.terapija" style="flex:0 0 50%; width: 50%;">
            <p style="font-weight:bold; margin-bottom: 0;">Terapija</p>
            <p>{{ examinationInfo.terapija }}</p>
          </div>
          <div v-if="examinationInfo.napomena" style="flex:0 0 50%; width: 50%;">
            <p style="font-weight:bold; margin-bottom: 0;">Napomena</p>
            <p>{{ examinationInfo.napomena }}</p>
          </div>
          <div style="flex: 0 0 100%; widht: 100%;" v-if="examinationInfo.vaccine.name || examinationInfo.vaccine.type || examinationInfo.vaccine.date || examinationInfo.vaccine.nextDate">
          <h5 style="text-decoration: underline; margin-top: 20px; margin-bottom: 5px;">Vakcina</h5>
          <div style="display: flex; flex-wrap: wrap; flex: 0 0 100%; width: 100%;">
            <div v-if="examinationInfo.vaccine.name" style="flex:0 0 50%; width: 50%;">
            <p style="font-weight:bold; margin-bottom: 0;">Ime vakcine</p>
            <p>{{ examinationInfo.vaccine.name }}</p>
          </div>
          <div v-if="examinationInfo.vaccine.type" style="flex:0 0 50%; width: 50%;">
            <p style="font-weight:bold; margin-bottom: 0;">Tip vakcine</p>
            <p>{{ examinationInfo.vaccine.type }}</p>
          </div>
          <div
            v-if="
              examinationInfo.vaccine.date &&
              (examinationInfo.vaccine.type || examinationInfo.vaccine.name)
            "
            style="flex:0 0 50%; width: 50%;"
          >
            <p style="font-weight:bold; margin-bottom: 0;">Datum vakcinacije</p>
            <p>{{ examinationInfo.vaccine.date }}</p>
          </div>
          <div
            v-if="
              examinationInfo.vaccine.nextDate &&
              (examinationInfo.vaccine.type || examinationInfo.vaccine.name)
            "
            style="flex:0 0 50%; width: 50%;"
          >
            <p style="font-weight:bold; margin-bottom: 0;">Datum naredne vakcinacije</p>
            <p>{{ examinationInfo.vaccine.nextDate }}</p>
          </div>
          </div>
        </div>
          <div v-if="examinationInfo.price" style="flex:0 0 100%; width: 100%;">
            <p style="font-weight:bold; margin-bottom: 0; color: green;">Cena:</p>
            <p style="color: green;">{{ examinationInfo.price }}din</p>
          </div>
          </div>
        <div style="display:flex; justify-content:space-between; margin-top:80px; flex: 0 0 100%; width: 100%;">
          <div style="flex: 0 0 33.33%; width: 33.33%;">
            <p>{{ new Date() | formatDate }}</p>
            <p>Vlasnik</p>
            <p>_________________________</p>
          </div>
          <div style="flex: 0 0 33.33%; width: 33.33%; text-align: center;">
            <p>M.P.</p>
          </div>
          <div style="flex: 0 0 33.33%; width: 33.33%; text-align: right;">
            <p style="color:#fff!important;">-</p>
            <p>Veterinar</p>
            <p>_________________________</p>
          </div>
        </div>
      </div>
      <div class="d-flex justify-end">
        <v-btn
          color="text--white teal darken-2 mr-2"
          v-if="!printingInProgress && !$route.query.mail"
          @click="print()"
          >PRINT</v-btn
        >
        <v-btn
          color="text--white teal darken-2 mr-2"
          v-if="!printingInProgress && $route.query.mail"
          @click="sendEmail()"
          >MAIL</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      printBtn: false,
    };
  },
  computed: {
    ...mapState([
      "myInfo",
      "printingInProgress",
      "petInfo",
      "examinationInfo",
      "ownerInfoCertificate",
    ]),
  },
  methods: {
    print() {
      this.$store.state.printingInProgress = true;
      setTimeout(() => {
        window.print();
        this.$store.state.printingInProgress = false;
      }, 500);
    },
    sendEmail() {
      var body = document.getElementById("mailThis").innerHTML;
      var html = '<!DOCTYPE html><html><head><title>Veterinar</title></head><body>' + body + '</body></html>'
      var obj = {
        cc: [""],
        bcc: [""],
        to: [this.ownerInfoCertificate.email],
        body: html,
        subject: "Potvrda o pregledu"
      };
      this.$store.dispatch("sendEmail", obj);
    },
  },
  mounted() {
    this.$store.dispatch("getPet", this.$route.query.petId);
    this.$store.dispatch("getOwnerInfoCertificate", this.$route.query.petId);
    this.$store.dispatch("getExamination", this.$route.query.appointmentId);
  },
  filters: {
    formatDate: (value) => {
      if (value) return moment(String(value)).format("YYYY-MM-DD");
      else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.print {
  h2,
  h1 {
    text-align: center;
  }
  * {
    color: #000;
  }
}
</style>